import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ActivityIndicator } from "react-native-web";

import { useContactNumberResponse } from "screens/question/hooks";
import Countries, { CountriesList } from "assets/countries";
import {
  Container,
  DialCode,
  CountryFlag,
  CountryCodeText,
  Wrapper,
  StyledTextInput,
  Label,
  CountryPicker,
  CountryPickerItem,
} from "./styled";
import { useEffect } from "react";
import { setIPBasedCountryCode } from "state/modules/customer";

export const ContactNumberQuestion = ({ question }) => {
  const {
    RTL,
    value,
    onChange,
    hasError,
    countryCode,
    placeholder,
    updateDialCode,
    validateCellphone,
  } = useContactNumberResponse(question);
  const [focus, setFocus] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIPBasedCountryCode());
  }, [dispatch]);

  return (
    <Container $RTL={RTL} $hasError={hasError} $isFocused={focus || value}>
      {countryCode == "EMPTY" ? (
        <ActivityIndicator size="large" color="gray" />
      ) : (
        <DialCode>
          <CountryFlag source={Countries[countryCode].flag} />
          <CountryCodeText>
            (+{Countries[countryCode].dialCode})
          </CountryCodeText>
          <CountryPicker
            mode="dialog"
            selectedValue={countryCode}
            onValueChange={dialCode => updateDialCode(dialCode, value)}
          >
            {CountriesList.map(country => (
              <CountryPickerItem
                label={country.name}
                key={country.countryCode}
                value={country.countryCode}
              />
            ))}
          </CountryPicker>
        </DialCode>
      )}
      <Wrapper>
        <StyledTextInput
          value={value}
          onChangeText={onChange}
          keyboardType="phone-pad"
          onFocus={() => setFocus(true)}
          $hasError={hasError}
          onBlur={() => {
            setFocus(false);
            validateCellphone(value);
          }}
        />
        <Label $RTL={RTL} pointerEvents="none" $isFocused={focus || value}>
          {placeholder}
        </Label>
      </Wrapper>
    </Container>
  );
};
